<template>
    <!-- 权限管理-角色管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'role')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="角色名称">
                        <a-input placeholder="请输入" v-decorator="['roleName']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="角色状态">
                        <a-select allowClear v-decorator="['isEnable']" @select="search">
                            <a-select-option :value="0">已冻结</a-select-option>
                            <a-select-option :value="1">使用中</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button class="mr8" type="primary" @click="search">筛选</a-button>
                        <a-button @click="reset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card :bordered="false">
                <a-button slot="extra" v-if="getBtnByAuth('addRole')" type="primary" @click="$router.push({name: 'addRole'})">新增角色</a-button>
                <a-table
                    bordered
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="pagination"
                    :loading="loading"
                    :rowKey="record => record.id"
                >
                    <span slot="isEnable" slot-scope="key">{{key ? '使用中' : '已冻结'}}</span>
                    <span slot="action" slot-scope="text, record">
                        <span v-if="getBtnByAuth('detailRole')">
                            <router-link class="text-primary" :to="{name:'detailRole',query: {id: record.id, edit:false}}">详情</router-link>
                            <a-divider type="vertical"/>
                        </span>
                        <span v-if="getBtnByAuth('updateRole')">
                            <router-link class="text-primary" :to="{name:'editRole',query: {id: record.id,edit:true}}">编辑</router-link>
                            <a-divider type="vertical"/>
                        </span>
                        <a-popconfirm v-if="getBtnByAuth('roleState')" :title="'确认将该角色'+ record.isEnable ? '冻结' : '解冻'" @confirm="changeState(record)">
                            <a class="text-primary">{{record.isEnable ? '冻结' : '解冻'}}</a>
                        </a-popconfirm>
                    </span>
                </a-table>
            </a-card>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
import { mapGetters } from "vuex";
const columns = [
    {
        title: "角色ID",
        dataIndex: "id"
    },
    {
        title: "角色",
        dataIndex: "roleName"
    },
    {
        title: "用户状态",
        dataIndex: "isEnable",
        scopedSlots: { customRender: "isEnable" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }
];

export default {
    name: "",
    components: {},
    props: {},
    data() {
        return {
            options: [],
            columns,
            dataSource: [],
            pagination: {
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                pageSize: 20,
                current: 1,
                showTotal() {
                    return `共 ${this.total} 条数据`
                },
                // 尺寸变化
                onShowSizeChange: (current, size) => {
                    this.sizeChange(current, size)
                },
                // 页码变化
                onChange: (page, pageSize) => {
                    this.currentChange(page, pageSize)
                }
            },
            loading: true
        };
    },
    computed: {
        ...mapGetters(["shopId"])
    },

    beforeCreate() {
        this.form = this.$form.createForm(this);
    },
    methods: {
        // 分页器操作
        sizeChange(current, size) {
            this.pagination.current = 1;
            this.pagination.pageSize = size;
            this.getList();
        },
        currentChange(page, pageSize) {
            this.pagination.current = page;
            this.getList();
        },

        // 重置搜索条件
        reset(){
            this.form.resetFields()
            this.getList()
        },
        search() {
            this.pagination.current = 1;
            this.getList();
        },

        // 获取数据列表
        getList() {
            if(!this.shopId) return
            let { current, pageSize } = this.pagination;
            let searchParams = this.form.getFieldsValue();
            if (typeof searchParams.isEnable !== 'undefined') {
                searchParams.isEnable = Boolean(searchParams.isEnable);
            }
            this.loading = true;
            this.$api.jurisdiction
                .roleList({
                    body: {
                        pageNum: current,
                        pageSize,
                        shopId:this.shopId,
                        ...searchParams
                    }
                })
                .then(res => {
                    this.loading = false
                    this.dataSource = res.list;
                    this.pagination.total = res.total;
                }).catch( err => {
                    this.loading = false
                })
        },
        // 冻结、解冻
        changeState(record){
            let {isEnable,id} = record;
            this.$api.jurisdiction[isEnable ? 'roleFreeze' : 'roleUnfreeze']({
                params: {
                    id
                }
            }).then(data=>{
                this.$message.success(isEnable ? '冻结成功' : '解冻成功');
                this.getList();
            })
        },
    },
    created() {},
    mounted() {
        this.getList();
    },
    watch: {
        $route(val) {
            val.name == "role" && this.getList();
        },
        shopId (val) {
            this.getList();
        }
    }
};
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
</style>
